import { FIELDS } from './constants';

const defaultFields = [
  /*{
    field: 'commands',
    title: ' ',
    cell: 'commands',
    headerCell: 'commandsHeader',
    sortable: false,
    hidden: false,
    locked: true,
    width: 40,
  },
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },*/
  {
     key: 'id',
     field: FIELDS.ID,
     title: 'NCM No.',
     label: 'NCM No.',
     cell: 'navigation',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'dateCreated',
     field: FIELDS.DATE_CREATED,
     title: 'NCM Date',
     label: 'NCM Date',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'purchaseOrderId',
     field: FIELDS.PURCHASE_ORDER_ID,
     title: 'PO No',
     label: 'PO No',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'partNumber',
     field: FIELDS.PART_NUMBER,
     title: 'Part Number',
     label: 'Part Number',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'mfrName',
     field: FIELDS.MFR_NAME,
     title: 'Mfr',
     label: 'Mfr',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'vendorName',
     field: FIELDS.VENDOR_NAME,
     title: 'Vendor',
     label: 'Vendor',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'originatorName',
     field: FIELDS.ORIGINATOR_NAME,
     title: 'Originator',
     label: 'Originator',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateInspected',
     field: FIELDS.DATE_INSPECTED,
     title: 'Date Inspected',
     label: 'Date Inspected',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'quantity',
     field: FIELDS.QUANTITY,
     title: 'Quantity',
     label: 'Quantity',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'ncNumber',
     field: FIELDS.NCNUMBER,
     title: 'NonConf No',
     label: 'NonConf No',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dwgNumber',
     field: FIELDS.DWG_NUMBER,
     title: 'Dwg No',
     label: 'Dwg No',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'ncmActivityInspectionName',
     field: FIELDS.NCMACTIVITY_INSPECTION_NAME,
     title: 'NCM Activity Inspection',
     label: 'NCM Activity Inspection',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'description',
     field: FIELDS.DESCRIPTION,
     title: 'Description',
     label: 'Description',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'action',
     field: FIELDS.ACTION,
     title: 'Action',
     label: 'Action',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'ncmDispositionAction',
     field: FIELDS.NCMDISPOSITION_ACTION,
     title: 'NCM Disposition Action',
     label: 'NCM Disposition Action',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'responsibleManager',
     field: FIELDS.RESPONSIBLE_MANAGER,
     title: 'Responsible Manager',
     label: 'Responsible Manager',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'responsibleManagerDate',
     field: FIELDS.RESPONSIBLE_MANAGER_DATE,
     title: 'Responsible Management Date',
     label: 'Responsible Management Date',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'isCriticalNcForUseAsIsDisposition',
     field: FIELDS.IS_CRITICAL_NCFOR_USE_AS_IS_DISPOSITION,
     title: 'Is Critical NC For Use As Is Disposition',
     label: 'Is Critical NC For Use As Is Disposition',
     cell: 'checkMark',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'projectEngineer',
     field: FIELDS.PROJECT_ENGINEER,
     title: 'Project Engineer',
     label: 'Project Engineer',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'projectEngineerDate',
     field: FIELDS.PROJECT_ENGINEER_DATE,
     title: 'Project Engineer Date',
     label: 'Project Engineer Date',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'projectManagement',
     field: FIELDS.PROJECT_MANAGEMENT,
     title: 'Project Management',
     label: 'Project Management',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'projectManagementDate',
     field: FIELDS.PROJECT_MANAGEMENT_DATE,
     title: 'Project Management Date',
     label: 'Project Management Date',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dispositionApprovedBy',
     field: FIELDS.DISPOSITION_APPROVED_BY,
     title: 'Disposition Approved By',
     label: 'Disposition Approved By',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dispositionApprovedDate',
     field: FIELDS.DISPOSITION_APPROVED_DATE,
     title: 'Disposition Approved Date',
     label: 'Disposition Approved Date',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'correctiveActionDescription',
     field: FIELDS.CORRECTIVE_ACTION_DESCRIPTION,
     title: 'Corrective Action Description',
     label: 'Corrective Action Description',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'correctiveActionApprovedBy',
     field: FIELDS.CORRECTIVE_ACTION_APPROVED_BY,
     title: 'Corrective Action Approved By',
     label: 'Corrective Action Approved By',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'correctiveActionApprovedDate',
     field: FIELDS.CORRECTIVE_ACTION_APPROVED_DATE,
     title: 'Corrective Action Approved Date',
     label: 'Corrective Action Approved Date',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'closingNcmBy',
     field: FIELDS.CLOSING_NCM_BY,
     title: 'Closing Ncm By',
     label: 'Closing Ncm By',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'closingNcmDate',
     field: FIELDS.CLOSING_NCM_DATE,
     title: 'Closing Ncm Date',
     label: 'Closing Ncm Date',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dateModified',
     field: FIELDS.DATE_MODIFIED,
     title: 'Date Modified',
     label: 'Date Modified',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'active',
     field: FIELDS.ACTIVE,
     title: 'Active',
     label: 'Active',
     sortable: true,
     hidden: true,
     width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
